export default "__VITE_ASSET__1b5cb774__"